import React from 'react'

type SelectInputProps = {
  options: {
    value?: string
    label?: string
  }[]
  onChange?(...args: unknown[]): unknown
  value?: string
}

export function SelectInput({ options, onChange, value, ...rest }: SelectInputProps) {
  const hasEmptyOption = !value
  return (
    <select onChange={({ target: { value } }) => onChange?.(value)} style={{ width: 200 }} value={value} {...rest}>
      {hasEmptyOption && <option value={value}>{value}</option>}
      {options.map(({ value: currentValue, label }: any) => (
        <option key={currentValue} value={currentValue}>
          {label}
        </option>
      ))}
    </select>
  )
}
